import React, { useState, Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { useContextBridge } from '@react-three/drei'
import * as THREE from 'three'
import { HelmetProvider } from 'react-helmet-async'
import { Perf } from 'r3f-perf'
import { ArrowLeftRight, ZoomIn } from 'lucide-react'

import { SceneXyz3D } from './experience/SceneXyz3D.jsx'
import { OrbitNavigation } from './OrbitNavigation.jsx'
import
{
  HtmlOverlay,
  ProgressLoader,
  SplashScreen,
  Seo,
  WebCrafterProvider,
  useWebCrafter,
  WebCrafterContext,
  isDebugMode,
} from '@webcrafter/common'

const GL_CONFIG = {
  alpha: false,
  toneMapping: THREE.ACESFilmicToneMapping,
  toneMappingExposure: 1,
}

const SCENE_PATH = 'assets/scene.glb'

const TUTORIAL_STEPS = [
  {
    icon: <ArrowLeftRight className="text-blue-400" />,
    title: 'Navigate',
    description: 'Use arrow keys or dots to switch between views.'
  },
  {
    icon: <ZoomIn className="text-purple-400" />,
    title: 'Zoom & Orbit',
    description: 'Scroll to zoom, drag to orbit around.'
  }
]

export function Xyz3D()
{
  const isDebugging = isDebugMode

  return (
    <HelmetProvider>
      <WebCrafterProvider isDebugging={isDebugging}>
        <WebCrafterApp />
      </WebCrafterProvider>
    </HelmetProvider>
  )
}

function WebCrafterApp()
{
  const [ showPopup, setShowPopup ] = useState(false)
  const [ popupContent, setPopupContent ] = useState(null)
  const [ xyzAPI, setXyzAPI ] = useState(null)
  const { isLoaded, isDebugging } = useWebCrafter()
  const ContextBridge = useContextBridge(WebCrafterContext)

  return (
    <>
      <div className="absolute inset-0 bg-black">
        <Canvas shadows="soft" gl={GL_CONFIG}>
          <ContextBridge>
            <Suspense fallback={null}>
              <SceneXyz3D
                path={SCENE_PATH}
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                isDebugging={isDebugging}
                setXyzAPI={setXyzAPI}
              />
            </Suspense>
            {isDebugging && <Perf />}
          </ContextBridge>
        </Canvas>
      </div>

      {!isLoaded && <ProgressLoader />}

      <HtmlOverlay
        content={popupContent}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
      />

      {isLoaded && (
        <SplashScreen
          tutorial={TUTORIAL_STEPS}
          title="3D Viewer"
          body="Explore these objects in 3D."
          buttonText="Start Exploring"
        />
      )}

      {isLoaded && <OrbitNavigation xyzAPI={xyzAPI} />}
      {isLoaded && <Seo />}
    </>
  )
}

export default Xyz3D
